import React from "react";

const Loader = () => {
  return (
    <>
      <div className="loader_bg">
        <div className="loader_img">
          <img src="/assets/images/loader.png" alt="" />
        </div>
      </div>
    </>
  );
};

export default Loader;
